function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M.392.206h57.346v70.611H.392z"
}));

var _ref2 = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(27 -.023)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  d: "M8.226 14.422s-5.134 8.3-4.772 12.605c.266 3.187 2.208 1.995 2.208 4.416 0 2.421-5.27 7.05-5.27 9.187 0 2.137 4.343 3.418 4.343 3.418s.308 2.611-.498 3.704c0 0 .285 1.804 1.234 1.804 0 0-1.14.997 0 1.9 0 0 1.377 2.657 0 4.652-1.377 1.994-.76 4.653 2.659 4.653 3.418 0 13.16-2.49 16.245 5.344 2.142 5.434 18.654 7.171 24.775-.248 2.702-3.276-1.042-20.313-1.042-20.313S71.181 17.555 45.9 4.95C20.618-7.656 12.142 8.154 8.225 14.422",
  fill: "#BEFFFC",
  mask: "url(#b)"
})), React.createElement("path", {
  d: "M25.124 27.004c.267 3.187 2.207 1.994 2.207 4.415 0 2.422-5.27 7.051-5.27 9.188 0 2.136 4.344 3.418 4.344 3.418s.309 2.611-.498 3.704c0 0 .284 1.803 1.235 1.803 0 0-1.14.997 0 1.9 0 0 1.377 2.658 0 4.652-1.377 1.994-.76 4.653 2.658 4.653 3.419 0 13.16-2.49 16.246 5.344 2.14 5.435 18.652 7.171 24.773-.248 2.702-3.275-1.042-20.312-1.042-20.312s23.075-27.99-2.208-40.595C42.287-7.68 33.812 8.131 29.895 14.4c0 0-2.111 3.413-3.53 6.998",
  stroke: "#28348A",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M30.34 29.618s-.62 1.69.226 2.281c.844.592 3.21-.59 3.21-.59s-1.464-1.775-3.436-1.69z",
  stroke: "#28348A",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M42.412 23.328a1.295 1.295 0 1 0 2.59.001 1.295 1.295 0 0 0-2.59 0m4.634 4.395a1.295 1.295 0 1 0 2.59 0 1.295 1.295 0 0 0-2.59 0m4.464-7.769a1.295 1.295 0 1 0 2.59 0 1.295 1.295 0 0 0-2.59 0m5.587 3.339a1.295 1.295 0 1 0 2.59 0 1.295 1.295 0 0 0-2.59 0",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M37.915 23.496c0 7.454 6.043 13.498 13.498 13.498 7.455 0 13.498-6.044 13.498-13.498 0-7.455-6.043-13.498-13.498-13.498-7.455 0-13.498 6.043-13.498 13.498z",
  stroke: "#28348A",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M40.21 23.581c.018-.326.049-.649.094-.967.77-5.44 5.459-9.639 11.109-9.639M40.462 27.5a11.13 11.13 0 0 1-.44-2.423m11.391 10.338c-3.274 0-6.226-1.41-8.278-3.654m16.324 2.294l6.753 6.753v-.001l.024.025a1.84 1.84 0 1 0 2.605-2.603c-.008-.01-.018-.016-.027-.025l.002-.001-6.753-6.752m-18.841-7.955a1.41 1.41 0 1 0 2.819.001 1.41 1.41 0 0 0-2.82 0zm15.016 0a1.41 1.41 0 1 0 2.82.001 1.41 1.41 0 0 0-2.82 0zm-10.307 4.361a1.411 1.411 0 1 0 2.823 0 1.411 1.411 0 0 0-2.822 0zm4.39-7.697a1.411 1.411 0 1 0 2.823-.001 1.411 1.411 0 0 0-2.823 0zm-9.099 3.336h-4.047m-2.789 0h-.733",
  stroke: "#28348A",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M32.684 23.496h-7.42",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "1.484,2.968,1.484,2.968"
}), React.createElement("path", {
  d: "M23.78 23.496H11.906",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "1.484,2.968,1.484,2.968,1.484,2.968"
}), React.createElement("path", {
  d: "M10.423 23.496H9.69m60.542 0h-4.047m-2.755 0h-2.37m-15.463 1.029l2.48 2.48m2.233-.275l2.894-5.265m1.819-.578l3.28 1.984m-58.12.993a4.572 4.572 0 1 0 9.145 0 4.572 4.572 0 0 0-9.144 0z",
  stroke: "#28348A",
  strokeWidth: 0.4
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 85 71",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/ecoSystem/forecast.svg